/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-26, 16:27:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-27, 13:02:30
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { hReturnAsProperlyRedirectUrl } from '@/utils/helpers';
import BrandButton from '@/components/Common/BrandButton';

export default {
  name: 'GoBackToSalesServicePoint',

  components: { BrandButton },

  props: {
    redirectUrl: {
      type: String,
      default: null,
    },
    asError: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      intervalObject: null,
      intervalToAutoRedirect: 5000,
    };
  },

  mounted() {
    this.intervalObject = setInterval(this.countdownToAutoRedirect, 1000);
  },

  computed: {
    secondsToAutoRedirect() {
      return this.intervalToAutoRedirect / 1000;
    },
    buttonColors() {
      const successColors = { main: '#33691e', accent: '#7cb342' };
      const errorColors = { main: '#C62828', accent: '#dd3030' };

      return this.asError ? errorColors : successColors;
    },
  },

  methods: {
    redirectToSalesServicePoint() {
      if (this.redirectUrl) window.location.href = hReturnAsProperlyRedirectUrl(this.redirectUrl);
    },

    countdownToAutoRedirect() {
      this.intervalToAutoRedirect -= 1000;
      if (this.intervalToAutoRedirect <= -1) {
        this.intervalToAutoRedirect = 0;
        clearInterval(this.intervalObject);
        this.redirectToSalesServicePoint();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/AfterPaymentPage/GoBackToSalesServicePoint/component.js